//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import TRA_BASIC_1Function from '../TRA_BASIC_01/TRA_BASIC_01F';
import TRA_BASIC_2Function from '../TRA_BASIC_02/TRA_BASIC_02F';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSearchInfo,
  setSearchText,
} from '../../../../Reducer/SearchReducer';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TRA_BASIC(props) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="TrainingPage"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          deleteYn="Y"
          printYn={props.value === 0 ? 'Y' : 'N'}
          addClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setAddClick1(true);
            else if (props.value === 1) props.setAddClick4(true);
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;
            // 수정: 직접 할당 대신 dispatch 사용
            dispatch(setSearchText(e));
            if (props.value === 0) props.setFilterClick1(true);
            else if (props.value === 1) props.setFilterClick4(true);
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setSaveClick1(true);
            else if (props.value === 1) props.setSaveClick4(true);
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setDeleteClick1(true);
            else if (props.value === 1) props.setDeleteClick4(true);
          }}
          printClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setPrintClick1(true);
            else if (props.value === 1) props.setPrintClick4(true);
          }}
          conditions={[
            ...(props.value === 0
              ? [
                  {
                    type: 'datePicker',
                    views: ['year', 'month'],
                    openTo: 'month',
                    title: '월',
                    name: '조회년월',
                    value: dayjs(
                      `${searchInfo.year}-${searchInfo.month}`,
                      'YYYY-MM'
                    ),
                    onChange: async (date) => {
                      if (date) {
                        dispatch(
                          setSearchInfo({
                            year: dayjs(date).format('YYYY'),
                            month: dayjs(date).format('MM'),
                          })
                        );
                        await props.setSearchClick1(true);
                      }
                    },
                    format: 'YYYY-MM',
                  },
                ]
              : [
                  {
                    type: 'datePicker',
                    title: '기간',
                    name: '교육일시(시작)',
                    value: dayjs(props.startDate),
                    onChange: async (date) => {
                      props.handleStartDateChange(date);
                      await props.setSearchClick4(true);
                    },
                  },
                  {
                    type: 'datePicker',
                    title: '기간',
                    name: '교육일시(끝)',
                    value: dayjs(props.endDate),
                    onChange: async (date) => {
                      props.handleEndDateChange(date);
                      await props.setSearchClick4(true);
                    },
                  },
                ]),
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList,
                    value: searchInfo.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);
                      props.value === 0
                        ? props.setSearchClick1(true)
                        : props.setSearchClick4(true);
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList,
              value: searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);
                props.value === 0
                  ? props.setSearchClick1(true)
                  : props.setSearchClick4(true);
              },
            },
          ]}
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="training tabs"
                >
                  <Tab
                    label="교육현황"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    {...A11yProps(1)}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            fontSize: '0.95rem',
                            fontWeight: 'bold',
                            color: '#000',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          교육자료
                        </span>
                        {props.value === 1 && (
                          <Box
                            sx={{
                              ml: 1,
                              backgroundColor: '#fff8e1',
                              px: 1,
                              borderRadius: '4px',
                              border: '1px solid #ffe082',
                              color: '#e65100',
                              fontWeight: 500,
                              fontSize: '0.75rem',
                              maxWidth: 250,
                              whiteSpace: 'normal',
                              lineHeight: 1.2,
                            }}
                          >
                            * 교육자료를 다중 소속에 일괄 등록할 경우 오른쪽{' '}
                            <u>추가버튼</u>을 이용해주세요.
                          </Box>
                        )}
                      </Box>
                    }
                  />
                </Tabs>
              </Box>

              <CustomTabPanel value={props.value} index={0}>
                <TRA_BASIC_1Function
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <TRA_BASIC_2Function
                  filterClick4={props.filterClick4}
                  setFilterClick4={props.setFilterClick4}
                  searchClick4={props.searchClick4}
                  setSearchClick4={props.setSearchClick4}
                  addClick4={props.addClick4}
                  setAddClick4={props.setAddClick4}
                  saveClick4={props.saveClick4}
                  setSaveClick4={props.setSaveClick4}
                  deleteClick4={props.deleteClick4}
                  setDeleteClick4={props.setDeleteClick4}
                  printClick4={props.printClick4}
                  setPrintClick4={props.setPrintClick4}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default TRA_BASIC;
